import { marked } from "marked";
window.marked = marked;

// Bootstrap is loaded globally by AdminKit's bundled app.js.
// Do NOT import bootstrap here — a second instance doubles data-api listeners,
// causing every dropdown/collapse toggle to fire twice (open then immediately close).
const bootstrap = window.bootstrap;

console.log("Application loaded successfully");

// Persist sidebar collapsed state across page loads.
// AdminKit toggles the `.collapsed` class on `#sidebar` when `.js-sidebar-toggle`
// is clicked. We read the resulting state and store it in a cookie that the
// server uses to render the correct initial state (no animation flash).
document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".js-sidebar-toggle");
  const sidebar = document.querySelector("#sidebar");
  if (!toggle || !sidebar) return;
  toggle.addEventListener("click", () => {
    // AdminKit's own click handler runs synchronously; defer one tick so we
    // observe the post-toggle class state.
    setTimeout(() => {
      const collapsed = sidebar.classList.contains("collapsed");
      const oneYear = 60 * 60 * 24 * 365;
      const value = collapsed ? "1" : "";
      const maxAge = collapsed ? oneYear : 0;
      document.cookie = `sidebar_collapsed=${value}; path=/; max-age=${maxAge}; samesite=lax`;
    }, 0);
  });
});

const dispatchFolderSelection = (folderId) => {
  const event = new CustomEvent("visualization-folder:selected", {
    detail: { folderId }
  });
  window.dispatchEvent(event);
};

document.addEventListener("click", (event) => {
  const link = event.target.closest("[data-folder-action='select']");
  if (!link) return;

  const folderIdAttr = link.getAttribute("data-folder-id");
  const folderId = folderIdAttr ? Number(folderIdAttr) : null;

  if (link.dataset.bsToggle === "collapse") {
    event.preventDefault();
    const targetSelector = link.getAttribute("data-bs-target");
    if (targetSelector) {
      const target = document.querySelector(targetSelector);
      if (target) {
        const isShown = target.classList.contains("show");
        const collapse = bootstrap.Collapse.getOrCreateInstance(target, { toggle: false });
        if (isShown) {
          collapse.hide();
          link.classList.add("collapsed");
          link.setAttribute("aria-expanded", "false");
        } else {
          collapse.show();
          link.classList.remove("collapsed");
          link.setAttribute("aria-expanded", "true");
        }
      }
    }
  } else {
    event.preventDefault();
  }

  document
    .querySelectorAll("[data-folder-action='select'].active")
    .forEach((el) => el.classList.remove("active"));
  link.classList.add("active");

  dispatchFolderSelection(folderId);
});
